module.exports = __webpack_public_path__ + "img/esteghrar.93dd28d.svg";